function getScrollbarWidth() {
  // Create a temporary div to measure the scrollbar
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // Force scrollbar
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

const scrollbarWidth = getScrollbarWidth();

function addWindowPadding() {
    const pageWrapper = document.getElementById('smooth-wrapper');
    const header      = document.querySelector('.js-header-bar');
    const navToggle   = document.querySelector('.js-nav-toggle');
    const navMenu     = document.querySelector('#site-navigation');

    if (pageWrapper && header) {
        // Check if the scrollbar is currently visible
        const scrollbarVisible = document.body.scrollHeight > window.innerHeight;

        if (scrollbarVisible) {
            // Set a CSS variable with the scrollbar width
            pageWrapper.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
            pageWrapper.classList.add('overlay-open-padding');

            // Get the current padding-right of the header
            const currentPadding = parseFloat(getComputedStyle(header).paddingRight) || 0;
            let newPadding = currentPadding + scrollbarWidth;
            header.style.paddingRight = `${newPadding}px`;
            if (navToggle) {
                const toggleMarginRight = parseFloat(getComputedStyle(navToggle).marginRight) || 0;
                navToggle.style.marginRight = `${toggleMarginRight + scrollbarWidth}px`;
            }
            if (navMenu) {
                const menuPaddingRight = parseFloat(getComputedStyle(navMenu).paddingRight) || 0;
                navMenu.style.paddingRight = `${menuPaddingRight + scrollbarWidth}px`;
            }
        }
    }
}

function clearWindowPadding() {
    const pageWrapper = document.getElementById('smooth-wrapper');
    const header      = document.querySelector('.js-header-bar');
    const navToggle   = document.querySelector('.js-nav-toggle');
    const navMenu     = document.querySelector('#site-navigation');

    if (pageWrapper && header) {
        pageWrapper?.style.removeProperty('--scrollbar-width');
        header?.style.removeProperty('padding-right');
        pageWrapper?.classList.remove('overlay-open-padding');
        navToggle?.style.removeProperty('margin-right');
        navMenu?.style.removeProperty('padding-right');
    }
}


export { getScrollbarWidth, scrollbarWidth, addWindowPadding, clearWindowPadding };